// extracted by mini-css-extract-plugin
module.exports = {"darkHeader":"newCondominium_darkHeader__3GCkl","formContainer":"newCondominium_formContainer__2naR1","formNewCondominium":"newCondominium_formNewCondominium__3wI_m"};